import CityPageTemplate from "../city-template/CityPageTemplate";
import { whitefishConfig } from "./data";

export default function WhitefishPage() {
  return <CityPageTemplate config={whitefishConfig} />;
}